import React from 'react';

export interface WorkspaceTab<K extends string> {
  key: K;
  label: string;
  count?: number;
}

interface WorkspaceTabPillsProps<K extends string> {
  tabs: WorkspaceTab<K>[];
  active: K;
  onSelect: (key: K) => void;
}

/** Seletor de abas em pílulas, para dentro de uma `WorkspaceSection`. Aba com `count` 0 fica desabilitada. */
function WorkspaceTabPills<K extends string>({ tabs, active, onSelect }: WorkspaceTabPillsProps<K>) {
  return (
    <div className="flex flex-wrap gap-1.5 border-t border-slate-100 px-5 py-3 dark:border-slate-800">
      {tabs.map(tab => (
        <button
          key={tab.key}
          type="button"
          disabled={tab.count === 0}
          onClick={() => onSelect(tab.key)}
          className={`rounded-full px-3 py-1.5 text-xs font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
            active === tab.key
              ? 'bg-indigo-600 text-white'
              : 'bg-slate-100 text-slate-600 hover:bg-slate-200 disabled:hover:bg-slate-100 dark:bg-slate-800 dark:text-slate-300 dark:hover:bg-slate-700 dark:disabled:hover:bg-slate-800'
          }`}
        >
          {tab.label}{tab.count !== undefined ? ` (${tab.count})` : ''}
        </button>
      ))}
    </div>
  );
}

export default WorkspaceTabPills;
